import Logo from '../assets/La-lepre-pos-logo-footer.png'
import Wa from '../assets/svg/wa.svg?react'
import { GlobalProvider, useGlobal } from "../contexts/GlobalContext";
function Footer() {
  const currentYear = new Date().getFullYear()
  const { directusGlobals } = useGlobal();
  return (
    <footer className="footer bg-secondary-700 text-white py-8">
      <div className="footer__container max-w-content mx-auto px-8 lg:px-16">
        {/* Main Footer Content */}
        <div className="footer__content flex flex-col items-center space-y-6">
          {/* Logo and Text */}
          <div className="footer__brand h-28 w-28 flex flex-col items-center">
            <img
              src={Logo}
              alt="La Lepre Logo"
              className="footer__logo object-contain h-full w-full"
            />
          </div>

          {/* Contact Number */}
          <div className="footer__contact mt-6 flex gap-12">
            <a
              href={`https://wa.me/${directusGlobals.contact_whatsapp_number}`}
              className="footer__text-animation font-body text-lg font-thin text-white hover:text-secondary-200 transition-colors flex items-center"
            >
              Bookings and Information
              <Wa className="ml-2 h-5 w-5 fill-current text-white" />
            </a>
            <a
              href={`mailto:${directusGlobals.contact_email}`}
              className="footer__text-animation font-body text-lg font-thin text-white hover:text-secondary-200 transition-colors flex items-center">
                {`${directusGlobals.contact_email}`}
            </a>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="footer__bottom border-t border-secondary-600 mt-8 pt-4 space-y-2">
          <p className="footer__copyright font-body text-extralight text-sm text-secondary-300 text-center">
            © {currentYear} La Lepre Ceramica. All rights reserved.
          </p>
          <p className="footer__developer font-body text-xs text-secondary-500 text-center">
            Developed with love by{' '}
            <a
              href="https://leveraweb.com"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__developer-link hover:text-secondary-200 transition-colors underline"
              data-umami-event="Contact Button - Whatsapp"
              data-umami-event-name="Footer"
            >
              LEVERA.WEB
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
